import { isSameId } from "../../helpers";
export default function (store, { id }) {
    if (id) {
        const state = store.getState();
        const { rows } = state;
        const rowIndex = rows.findIndex(col => isSameId(col.id, id));
        const originalRow = rows[rowIndex];
        const before = rows[rowIndex + 1]?.id;
        rows.splice(rowIndex, 1);
        store.setState({ rows });
        return () => {
            store.in.exec("add-row", {
                row: originalRow,
                before,
                $meta: {
                    skipHistory: true,
                    restore: id,
                },
            });
        };
    }
}
//# sourceMappingURL=delete.js.map